const { defaultLocale, supportedLocales } = require('./i18n')

/**
 * Parse and validate registrationLang cookie value before using as lang prefix.
 *
 * @param incoming
 * @returns {*|string}
 */
export const registrationLangCookieToPathPrefix = (incoming) => {
  if (!incoming) {
    // If empty, just pass through in order to preserve existing behavior.
    return incoming
  }
  let incomingModified = incoming
  if (typeof incomingModified !== 'string' || incomingModified.length < 1) {
    // Not a string or string is empty. Use default language.
    return defaultLocale
  }
  if (!supportedLocales.includes(incomingModified)) {
    // Only attempt conversion if it is an unrecognized language code.
    const localeParts = incomingModified.split('-')
    if (localeParts.length === 2) {
      // This could be a locale like 'en-US' that needs the country part stripped off.
      incomingModified = localeParts[0]
    }
  }
  if (!supportedLocales.includes(incomingModified)) {
    // We have converted if needed, but it is still not a recognized language. Use default language.
    return defaultLocale
  }
  return incomingModified
}
